// extracted by mini-css-extract-plugin
export default {"root":"InEme2mvugCYP726VXsU"};